
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mhealth",
      function () {
        return require("private-next-pages/mhealth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mhealth"])
      });
    }
  